import * as yup from "yup";

export const inviteUserSchema = yup
  .object({
    email: yup
      .string()
      .required("Email is required")
      .email("Enter a valid email address")
      .default(""),
    first_name: yup.string().default(""),
    last_name: yup.string().default(""),
    role_ids: yup
      .array()
      .of(yup.number().required())
      .default([])
      .min(1, "Choose at least one role"),
  })
  .required();
